module.exports = __webpack_public_path__ + "static/media/apple-app-badge.0f322512.png";